document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".main-product-share-icon").forEach(btn => {

    const productUrl = btn.dataset.productUrl;
    const productTitle = btn.dataset.productTitle;

    if (!productUrl) return;

    btn.addEventListener("click", () => {
      if (navigator.share) {
        navigator.share({
          title: productTitle,
          url: productUrl
        }).catch(() => {});
      } else {
        navigator.clipboard.writeText(productUrl);
        alert("Product link copied!");
      }
    });

  });
});
